import { type OrgConfig, OrgConfigSchema } from '@cult/schemas';
import { type QueryClient, queryOptions, useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { apiFetch } from '../../../lib/api-client';
import { useOrgConfig } from '../../../state/use-org-config';

export const orgConfigQueryOptions = queryOptions<OrgConfig>({
  queryKey: ['org-config'],
  queryFn: async () => {
    const raw = await apiFetch<unknown>('/config');
    return OrgConfigSchema.parse(raw);
  },
  staleTime: Number.POSITIVE_INFINITY,
  retry: 1,
});

// For route guards: resolves the server config, loading it on a cold cache.
export const ensureOrgConfig = (queryClient: QueryClient): Promise<OrgConfig> =>
  queryClient.ensureQueryData(orgConfigQueryOptions);

export const useOrgConfigQuery = () => {
  const setConfig = useOrgConfig((s) => s.setConfig);

  const query = useQuery(orgConfigQueryOptions);

  useEffect(() => {
    if (query.data) {
      setConfig(query.data);
    }
  }, [query.data, setConfig]);

  return query;
};
